import httpAuth from '@/services/httpAuth'

export async function buscarDadosGrafico (data) {
  return httpAuth.post('/lucratividade/grafico', data)
}

export async function buscarDadosTabela (data) {
  return httpAuth.post('/lucratividade/tabela', data)
}

export async function buscarDadosTabelaDetalhesDia (data) {
  return httpAuth.post('/lucratividade/tabeladetalhesdia', data)
}

export async function exportarParaExcel (data) {
  return httpAuth.post('/lucratividade/exportarparaexcel', data)
}

export async function exportarParaExcelDetalhes (data) {
  return httpAuth.post('/lucratividade/exportarparaexceldetalhes', data)
}
